<div class="invoice-list" *ngIf="commission && commission.success && !calculateLoading">

	<!--Requested Amount-->
	<div class="table-row">
		<span>
			<ng-container *ngIf="payAmountTitle !== undefined">
				{{payAmountTitle | translate}}
			</ng-container>

			<ng-container *ngIf="payAmountTitle === undefined">
				{{'REQUEST.COMMISSION.SELL_AMOUNT' | translate}}
			</ng-container>
		</span>

		<span>
			<span class="text-color-grey-500 amount">
				<span class="number">
					{{commission.requestedAmount | tcCurrency: commission.requestedPrecision}}
				</span>
				<span class="currency">
					{{commission.requestedCurrencyCode}}
				</span>
			</span>
		</span>
	</div>

	<ng-container *ngIf="commission.commissionType !== commissionType.NONE">

		<!--Initial fee-->
		<div class="table-row">
			<span>
				<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
					{{'REQUEST.COMMISSION.INITIAL_COST' | translate}}
				</ng-container>

				<ng-container *ngIf="commission.commissionType === commissionType.BONUS">
					{{'REQUEST.COMMISSION.FIXED_AMOUNT' | translate}}
				</ng-container>
			</span>
			<span class="amount">
				<span class="number">
					{{commission.commissionInitialFee | tcCurrency: commission.requestedPrecision}}
				</span>
				<span class="currency" *ngIf="commission.commissionInitialFee > 0">
					{{commission.requestedCurrencyCode}}
				</span>

			</span>
		</div>

		<!--comission-->
		<div class="commission">

			<div class="table-row">
				<span>
					<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.COMMISSION' | translate}}
					</ng-container>

					<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.BONUS' | translate}}
					</ng-container>
					<ng-container *ngIf="commission.commissionPercent != 0">{{commission.commissionPercent}}%</ng-container>
					
				</span>

				<span class="commition-amount amount">
					<span class="number">
						{{ commission.commissionAmount | tcCurrency: commission.requestedPrecision }}
					</span>


					<span class="currency" *ngIf="commission.commissionAmount > 0">
						{{ commission.requestedCurrencyCode }}
					</span>
				</span>
			</div>

			<span class="data"
				*ngIf="(commission.minCommission > 0 || commission.maxCommission > 0) &&
                 commission.commissionAmount > 0 && (commission.commissionCalcType && commission.commissionCalcType !== commissionCalcType.CALCULATED)">

				<span class="red" *ngIf="commission.commissionCalcType === commissionCalcType.MINIMUM">
					<!--title-->
					<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.MINIMUM_COMMISION' | translate}}</ng-container>
					<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.MINIMUM_BONUS' | translate}}</ng-container>
					<!--amount-->
					<span class="amount">
						<span class="number">
							{{commission.minCommission | tcCurrency: commission.requestedPrecision }}
						</span>
						<span class="currency">
							{{commission.requestedCurrencyCode}}
						</span>
					</span>
				</span>

				<span class="red" *ngIf="commission.commissionCalcType === commissionCalcType.MAXIMUM">
					<!--title-->
					<ng-container *ngIf=" commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.MAXIMUM_COMMISION' | translate}}</ng-container>
					<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.MAXIMUM_BONUS' | translate}}</ng-container>

					<span class="amount">
						<span class="number">
							{{commission.maxCommission | tcCurrency: commission.requestedPrecision}}
						</span>
						<span class="currency">
							{{commission.requestedCurrencyCode}}
						</span>
					</span>
				</span>
			</span>

		</div>

		<!--Calculated amount-->
		<div class="table-row">
			<!-- <ng-container *ngIf="requestType !== requestTypes.Send"> -->
			<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
				{{'REQUEST.COMMISSION.CALCULATED_AMOUNT' | translate}}
			</ng-container>

			<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
				{{'REQUEST.COMMISSION.CALCULATED_AMOUNT_BUNOS' | translate}}
			</ng-container>

			<span class="amount">
				<span class="number">
					{{ commission.calculatedAmount | tcCurrency: commission.requestedPrecision }}
				</span>
				<span class="currency">
					{{commission.requestedCurrencyCode}}
				</span>

			</span>
		</div>

	</ng-container>

	<!--exchange rate-->
	<div class="table-row">
		<span>{{'REQUEST.COMMISSION.EXCHANGE_RATE' | translate}}</span>

		<span class="amount">
			<span class="number">
				{{ commission.exchangeRate | tcCurrency: 10 }}
			</span>
			<span class="currency" *ngIf="commission.exchangeRate !== 1">
				{{commission.exchangeCurrencyCode}}
			</span>
		</span>
	</div>

	<!--CONVERSION AMOUNT-->
	<div class="table-row" *ngIf="requestType === requestTypes.Send">
		<span>
			{{'REQUEST.COMMISSION.GET_AMOUNT_THIRD_PARTY' | translate}}
		</span>

		<span class="amount">
			<span class="number">
				{{commission.convertedAmount | tcCurrency: commission.payOrGetPrecision }}
			</span>
			<span class="currency">
				{{ commission.payOrGetCurrencyCode }}
			</span>
		</span>
	</div>

	<!--point-->
	<div class="point" *ngIf="commission.point">
		<span>
			{{'REQUEST.COMMISSION.POINT' | translate}} <i class="icon-question-mark-circl"></i>
		</span>

		<span>
			{{ commission.point | tcCurrency: pointPrecision }} <i class="icon-gift"></i>
		</span>
	</div>

	<!--get amount-->
	<div class="get-amount">
		<span>
			<ng-container *ngIf="getAmountTitle">
				{{getAmountTitle | translate}}
			</ng-container>

			<ng-container *ngIf="!getAmountTitle">
				{{'REQUEST.COMMISSION.GET_AMOUNT' | translate}}
			</ng-container>
		</span>

		<span class="amount" *ngIf="requestType !== requestTypes.Send">
			<span class="number">
				{{ commission.payOrGetAmount | tcCurrency: commission.payOrGetPrecision }}
			</span>
			<span class="currency">
				{{ commission.payOrGetCurrencyCode }}
			</span>
		</span>


		<span class="amount" *ngIf="requestType === requestTypes.Send">
			{{ commission.calculatedAmount | tcCurrency: commission.requestedPrecision }}
			<span class="currency">
				{{commission.requestedCurrencyCode}}
			</span>
		</span>
	</div>

</div>
